import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectMultiComponent = _resolveComponent("SelectMultiComponent")!
  const _component_InputBlock = _resolveComponent("InputBlock")!

  return (_openBlock(), _createBlock(_component_InputBlock, {
    title: "Субъект РФ",
    class: _normalizeClass(_ctx.itemsClass)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_SelectMultiComponent, {
        modelValue: _ctx.filter.regionRfId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.regionRfId) = $event)),
        options: _ctx.getRegionsListWithId,
        placeholder: _ctx.placeholders.region,
        classSelect: "multiselect--rectangular visible-clear",
        valueProp: "id",
        trackBy: "name",
        label: "name"
      }, null, 8, ["modelValue", "options", "placeholder"])
    ]),
    _: 1
  }, 8, ["class"]))
}